import { createFileRoute } from '@tanstack/react-router'
import { FoodDrinkSectionPage } from '@/features/setup/food-drink-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/food')({
  component: FoodDrinkSectionRoute,
})

function FoodDrinkSectionRoute() {
  const { workspaceSlug } = Route.useParams()

  return <FoodDrinkSectionPage workspaceSlug={workspaceSlug} />
}
